import { Col, Row } from "reactstrap";
import { H3 } from "../../../../AbstractElements";
import { ProductReview, RateNow } from "../../../../Constant";
import { Rating } from "react-simple-star-rating";
import { useState } from "react";

export const ProductRating = () => {
  const [rating, setRating] = useState(1);
  const changeRating = (newRating: number) => {
    setRating(newRating);
  };
  return (
    <>
      <Row>
        <Col md="4">
          <H3 className="product-title">{RateNow}</H3>
        </Col>
        <Col md="8">
          <div className="d-flex">
            <div className="rating">
              <Rating onClick={changeRating} initialValue={rating} size={17} />
            </div>
            <span className="ms-2">{ProductReview}</span>
          </div>
        </Col>
      </Row>
      <hr />
    </>
  );
};
